import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";

/** @type {import('../types').MobileTenantModule} */
const vbsus = {
  key: "vbsus",
  label: "VBS USA",
  domains: ["vbspecialties.com", "www.vbspecialties.com"],
  codePath: "public-web/src/mobile/vbsus",
  pages: {
    home: HomePage,
    download: HomePage,
    catalog: CatalogPage,
    productDetail: ProductDetailPage,
    cart: CartPage,
  },
};

export default vbsus;
